export default "__VITE_ASSET__BTCJB2rI__"